import { Platform, View, ViewProps } from "react-native";

import { cn } from "~/lib/utils";

export const Form = (
  props: (ViewProps | React.ComponentProps<"form">) & {
    onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
  },
) => {
  if (Platform.OS === "web")
    return (
      <form
        {...(props as React.ComponentProps<"form">)}
        role="form"
        className={cn("flex flex-col", props.className)}
        onSubmit={(e) => {
          if (props.onSubmit) {
            e.preventDefault();
            props.onSubmit(e);
          }
        }}
      >
        {props.children}
        <input type="submit" className="hidden" />
      </form>
    );

  return <View {...(props as ViewProps)} />;
};
